import { useState } from "react";
import "./CTA.scss";

export default function CTA() {

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const subscribeUser = async (emailAddress) => {

    const endpoint = "https://kotamconquest.com/subscribe/";
    const formData = new FormData();
    formData.append('email', emailAddress);
    formData.append('source', 'web');
    var resp = {'status': 'error'};
    try {
      if (window.fbq) {
        const leadEventId = crypto.randomUUID();
        window.fbq('track', 'Lead', {}, { eventID: leadEventId });
      }
      const req = await fetch(endpoint, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => data);
      resp =  req;
    }
    catch(error) {
      throw new Error("Subscribe failed");
    }
    // return await resp;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cleanedEmail = email.trim();

    if (!cleanedEmail) return;

    try {
      setStatus("loading");

      await subscribeUser(cleanedEmail);

      setStatus("success");
      sessionStorage.setItem("kotam_signup_complete", "true");
      window.location.assign("/thank-you");
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <section className="cta section" id="signup">
      <div className="cta__box">
        <span className="section-eyebrow">Founder list</span>
        <h2 className="section-title">Be Ready for Launch Day.</h2>
        <p className="section-copy">
          Join early access for Kickstarter updates, first-look previews, and the option to unlock the 3D Barrack promo at launch.
        </p>

        <form className="cta__form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            aria-label="Email address"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />

          <button
            className="btn btn-primary"
            type="submit"
            disabled={status === "loading"}
          >
            {status === "loading" ? "Joining..." : "Claim Early Access"}
          </button>
        </form>

        {status === "error" && (
          <p className="cta__error">
            Something went wrong. Please try again.
          </p>
        )}

        <small>No spam. Unsubscribe anytime.</small>
      </div>
    </section>
  );
}
